import { trackAdobeEvent } from './adobe';
import { recordPdfPageData } from '../newRelicBrowserActions';

export function trackPageLoad() {
  const loadTime = Math.floor(window.performance.now());

  window.pageData.page = {
    ...window.pageData.page,
    name: window.pageName,
    loadTime: loadTime.toString(),
    loadTimestamp: Date.now()
      .toString(),
  };

  trackAdobeEvent('newPage', window.pageData);
  recordPdfPageData(loadTime);
}
